// scenarios.ts — the 9 presets (Phase 0.3). Values match the prototype's SCEN.

import type { Drivers } from "./entities.ts";

export interface Scenario extends Drivers {
  l: string; // display label
}

export type ScenarioId =
  | "base"
  | "meltup"
  | "digestion"
  | "gasPivot"
  | "oaFail"
  | "anFail"
  | "winter"
  | "bondshock"
  | "shock";

export const SCEN: Record<ScenarioId, Scenario> = {
  base: { l: "Base case", capex: 1.00, cost: 1.00, ai: 1.00, oa: 1.00, an: 1.00, pw: 1.00, life: 6, y10: 4.79, y20: 5.27, y30: 5.27, sm: 1.00, gas: 0.25 },
  meltup: { l: "Melt-up", capex: 1.35, cost: 1.12, ai: 1.45, oa: 1.00, an: 1.00, pw: 1.30, life: 6, y10: 5.10, y20: 5.60, y30: 5.65, sm: 0.80, gas: 0.32 },
  digestion: { l: "Digestion", capex: 0.85, cost: 1.00, ai: 0.85, oa: 1.00, an: 1.00, pw: 1.00, life: 5, y10: 4.40, y20: 4.90, y30: 4.95, sm: 1.25, gas: 0.25 },
  gasPivot: { l: "Gas-to-power pivot", capex: 1.10, cost: 1.25, ai: 1.05, oa: 1.00, an: 1.00, pw: 1.35, life: 6, y10: 4.90, y20: 5.40, y30: 5.45, sm: 1.00, gas: 0.52 },
  oaFail: { l: "OpenAI default", capex: 0.75, cost: 1.00, ai: 0.70, oa: 0.15, an: 1.00, pw: 0.95, life: 4, y10: 4.20, y20: 4.75, y30: 4.85, sm: 2.10, gas: 0.22 },
  anFail: { l: "Anthropic default", capex: 0.85, cost: 1.00, ai: 0.80, oa: 1.00, an: 0.15, pw: 0.97, life: 5, y10: 4.45, y20: 4.95, y30: 5.00, sm: 1.70, gas: 0.24 },
  winter: { l: "AI winter", capex: 0.40, cost: 1.00, ai: 0.35, oa: 0.10, an: 0.10, pw: 0.85, life: 4, y10: 3.40, y20: 4.00, y30: 4.25, sm: 3.20, gas: 0.18 },
  bondshock: { l: "Bond shock", capex: 0.90, cost: 1.05, ai: 1.00, oa: 1.00, an: 1.00, pw: 1.05, life: 6, y10: 6.00, y20: 6.60, y30: 6.75, sm: 1.45, gas: 0.28 },
  shock: { l: "Cost & power shock", capex: 0.95, cost: 1.45, ai: 1.00, oa: 1.00, an: 1.00, pw: 1.60, life: 6, y10: 5.40, y20: 5.90, y30: 5.95, sm: 1.20, gas: 0.30 },
};

/** Drivers for a scenario, without the display label. */
export function scenarioDrivers(id: ScenarioId): Drivers {
  const { l: _l, ...drivers } = SCEN[id];
  return drivers;
}
